import { Action } from 'redux';

import {
  ServerUserAddToIdentityPool,
  ServerUserDelete,
  ServerUserEditSiteMembership, ServerUserForcePasswordUpdate,
  ServerUserRemoveFromIdentityPool,
  ServerUserResetLoginRateLimiting
} from '../../../bootstrap/redux/actions/AppActionTypes';
import { IServerUserInfo } from '../models/IServerUserInfo';

export interface ServerUserMenuAction extends Action {
  items: IServerUserInfo[];
}

export function serverUserDelete(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserDelete,
    items
  };
}

export function serverUserEditSiteMembership(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserEditSiteMembership,
    items
  };
}

export function serverUserForcePasswordUpdate(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserForcePasswordUpdate,
    items
  };
}

export function serverUserResetLoginRateLimiting(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserResetLoginRateLimiting,
    items
  };
}

export function serverUserAddToIdentityPool(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserAddToIdentityPool,
    items
  };
}

export function serverUserRemoveFromIdentityPool(items: IServerUserInfo[]): ServerUserMenuAction {
  return {
    type: ServerUserRemoveFromIdentityPool,
    items
  };
}
